import authApi, {User} from "../../api/user";
import nsiApi from "../../api/nsi";
import {BaseThunkType, InferActionTypes} from "../index";
import {setPromiseError} from "../reducers/error";
import {NsiItem, ResultCodeForCaptchaEnum} from "../../api/types";
import {securityAPI} from "../../api/security-api";

export const actions = {
    setAuthUserData: (user: User) => ({
        type: 'MB/USER/SET_USER_DATA', payload: user
    } as const),
    clearAuthUserData: () => ({type: 'MB/USER/CLEAR_USER_DATA'} as const),
    getCaptchaUrlSuccess: (captchaUrl: string) => ({
        type: 'MB/USER/GET_CAPTCHA_URL_SUCCESS', payload: {captchaUrl}
    } as const),
    setUserTypes: (values: NsiItem[]) => ({type: 'MB/USER/SET_USER_TYPES', values} as const),
    clearUserTypes: () => ({type: 'MB/USER/CLEAR_USER_TYPES'} as const),
    setDocTypes: (values: NsiItem[]) => ({type: 'MB/USER/SET_DOC_TYPES', values} as const),
    clearDocTypes: () => ({type: 'MB/USER/CLEAR_DOC_TYPES'} as const)
}
export type ActionsType = InferActionTypes<typeof actions>
type ThunkType = BaseThunkType<ActionsType>

export const getAuthUserData = (): ThunkType => async (dispatch) => {//return thunk(thunkCreator)
    try {
        let meData = await authApi.me(); // значение, которым promise зарезолвился(resolve)
        let user = meData.data;
        dispatch(actions.setAuthUserData(user));
    }
    catch (err) { dispatch(setPromiseError(err)) }
}

export const login = (email: string, password: string, rememberMe: boolean, captcha: string):ThunkType => async (dispatch) => {//return thunk(thunkCreator)
    let data = await authApi.login(email, password, rememberMe, captcha);
    if (data.code === 200) {
        // success, get auth data
        await dispatch(getAuthUserData());
    } else {
        if (data.code === ResultCodeForCaptchaEnum.CaptchaIsRequired) {//не работает в данный момент, можно с ===1 протестить
            await dispatch(getCaptchaUrl());
        }
        let message = data.message;
        /*let action = stopSubmit("login", {_error: message});*/
        /*dispatch(action);*/
    }
}

export const getCaptchaUrl = ():ThunkType => async (dispatch) => {
    const data = await securityAPI.getCaptchaUrl();
    const captchaUrl = data.url
    dispatch(actions.getCaptchaUrlSuccess(captchaUrl));
}

export const logout = (): ThunkType => async (dispatch) => {
    let response = await authApi.logout()
    if (response.data.code === 200) {
        dispatch(actions.clearAuthUserData());
    }
}

export const getUserTypes = (): ThunkType => async (dispatch) => {
    let response = await nsiApi.getUserTypes()
    dispatch(actions.setUserTypes(response.data));
}

export const getDocTypes = (): ThunkType => async (dispatch) => {
    let response = await nsiApi.getDocTypes()
    dispatch(actions.setDocTypes(response.data));
}